module.exports = __webpack_public_path__ + "img/254.68aa11cc.png";